import { Getter } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'
import { ArticleGetters } from '@/store/modules/article/types'
import { articleModule } from '@/store/namespaces'
import { RootGetters } from '@/store/types'
import { getArticleLocation } from '../helpers'

@Component
export default class ArticleLocationMixin extends Vue {
  @Getter('getPlatform')
  protected readonly platform!: RootGetters['getPlatform']

  @articleModule.Getter('articleTypeCode')
  protected readonly articleTypeCodeGetter!: ArticleGetters['articleTypeCode']

  protected getArticleLocation(params: {
    articleType: number
    articleId: number
  }) {
    return getArticleLocation({
      articleTypeCode: this.articleTypeCodeGetter(params.articleType),
      articleId: params.articleId,
      platform: this.platform,
    })
  }
}
